<template>
  <Column class="w-100b">
    <Row class="w-100b p-lr-16 p-t-16 p-b-12" x="sb">
      <span :class="titleClass || 'text-14px'">{{ tiitle }}</span>
      <Row>
        <slot name="tiitleRight">
          <IconSvg name="icon-IconArrowLeft_Home" class="font-18 pointer m-r-5" :class="listStart == 0 ? 'c-lInfo' : 'c-border'" @click="listStartChange(-showNum)" />
          <IconSvg name="icon-IconArrowRight_Home" class="font-18 pointer" :class="(listStart + showNum) >= list.length ? 'c-lInfo' : 'c-border'" @click="listStartChange(showNum)" />
        </slot>

      </Row>
    </Row>
    <slot name="a1" />
    <Column class="w-100b" y="s">
      <Column v-if="list.length == 0" class="w-100b" y="s" x="c">
        <ListEmpty class="p-tb-25" :size="78" :text="$t('table.noResultsFound')" />
      </Column>
      <Row
        v-for="(item) in list.slice(listStart, listStart + showNum)"
        :key="item.id + tabType + item.coinMarket"
        class="w-100b p-lr-16 min-h-60px py-8px pointer hover-lInfo"
        x="sb"
        y="c"
        @click="() => toTrade(item)"
      >
        <Row class="" x="s" y="c">
          <span v-if="!optional" class="font-14 m-r-12" :class="item.sIndex <= 3 ? 'c-warning' : 'text-9b'">{{ item.sIndex }}</span>
          <!-- <Optional class="f-size-12" :data="item" @onOptional="quotesStore.getContractTickers" /> -->
          <!-- <Optional
            v-else
            class="f-size-16 m-r-12"
            :isOptional="tabType == 2"
            :data="item"
            @onOptional="onOptional"
          /> -->
          <el-image v-if="tabType == 1" class="w-22 h-22 radius-50b m-r-8" :src="quotesStore.coinImageMap[item.coinMarket?.split('/')[0]]">
            <template #placeholder>
              <el-image class="w-22 h-22 " :src="coinDefaultImage" />
            </template>
            <template #error>
              <el-image class="w-22 h-22 " :src="coinDefaultImage" />
            </template>
          </el-image>
          <el-image v-else class="w-22 h-22 radius-50b m-r-8" :src="quotesStore.coinImageMap[item.coinMarket.replace('USDT','')]">
            <template #placeholder>
              <el-image class="w-22 h-22 " :src="coinDefaultImage" />
            </template>
            <template #error>
              <el-image class="w-22 h-22 " :src="coinDefaultImage" />
            </template>
          </el-image>
          <Column x="s" y="s">
            <Row v-if="tabType == 1" class="font-14">
              <span class="font-w-700">{{ item.coinMarket?.split('/')[0] }}</span>
              <span class="text-9b">/{{ item.coinMarket?.split('/')[1] }}</span>
            </Row>
            <Row v-else class="font-14">
              <span class="font-w-700">{{ item.coinMarket }}</span>
              <Row class="radius-2 m-l-4 bg-f4 text-10px px-2px py-1px lh-12px rd-2px">{{ $t('home.perp') }}</Row>
            </Row>
            <Row v-if="getStockNum(item.coinMarket)" class="text-12px text-9b">
              {{ getStockNum(item.coinMarket) }}
            </Row>
          </Column>
        </Row>
        <Column y="e" x="e">
          <Num class="font-14 font-w-700">{{ $f.toFixed(item.lastPrice, item.pricePrecision) }}</Num>
          <Row :class="$f.priceClass(item.rangeAbility)" x="s" class="num-f">
            <span class="num-f">{{ $f.pnFill(NP.times(+item.rangeAbility,100)) }}%</span>
          </Row>
        </Column>
      </Row>
    </Column>
  </Column>
</template>

<script setup>
import coinDefaultImage from '@/image/coinDefaultImage.webp'
const emit = defineEmits(['update:searchHistory'])

const props = defineProps({
  showNum: {
    default: 5,
  },
  list: {},
  searchHistory: {
    default: [],
  },
  tiitle: {},
  titleClass: {},
  tabType: {},
  runListEmpty: {
    default: true,
  },
  optional: {
    default: false
  },
  tabValue: {},
})
const quotesStore = useQuotesStore()
const getStockNum = coinMarket => props.tabType == 1
  ? props.list?.find(item => item.coinMarket === coinMarket)?.stockNum
  : quotesStore.getContractTicker(coinMarket)?.stockNum

const searchHistoryMaxLength = 6
const getRoutePath = (item) => {
  if (item?.stockType) {
    return props.tabType == 1 ? '/coinStockTrade' : '/coinStockFutures'
  }
  return props.tabType == 1 ? '/trade' : '/futures'
}
const getHistoryRoutePath = item => item?.routePath || (item?.type == 1 ? '/trade' : '/futures')

let listStart = $ref(0)
watch(
  () => props.tabValue,
  () => {
    listStart = 0
  }
)
const listStartChange = (n) => {
  if (n == -props.showNum && listStart != 0) {
    listStart += n
    return
  } else if (n == props.showNum && (listStart + props.showNum) < props.list.length) {
    listStart += n
    return
  }
}

// const onOptional = () => {
//   if (tabType == 1) {
//     quotesStore.getTickers()
//   } else if (tabType == 2) {
//     quotesStore.getContractTickers()
//   }
// }

const toTrade = (item) => {
  const routePath = getRoutePath(item)
  router.push({
    path: routePath,
    query: {
      symbol: item.coinMarket,
    },
  })
  const searchHistory = [...props.searchHistory.filter(e => e != '')]
  const data = { coinMarket: item.coinMarket, type: props.tabType, routePath }

  // 移除已存在的相同 coinMarket 记录
  const filteredHistory = searchHistory.filter(h => !(h.coinMarket === item.coinMarket && getHistoryRoutePath(h) === routePath))

  // 在数组头部插入新记录
  filteredHistory.unshift(data)

  // 控制最大长度
  if (filteredHistory.length > searchHistoryMaxLength) {
    filteredHistory.pop()
  }

  emit('update:searchHistory', filteredHistory)
}

onMounted(() => {

})

</script>

<style lang="scss">

.QuerySymbol{
  // transition: all 0.3s;
  position: absolute;
  .QuerySymbol-input{
    .el-input__wrapper{
      padding-left: 38px !important;
      border-radius: 38px !important;
    }
    .el-input__inner{
      --el-input-height: 32px;
      font-size: 12px !important;
      height: 32px !important;
    }
    .el-input__inner::placeholder{
      font-size: 12px !important;
    }
  }
}
</style>
